import { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Container from "../../Components/Atoms/layouts/container/Container";
import InlineLoader from '../../Components/Atoms/loader/InlineLoader';
import BlogDetailsCard from '../../Components/Organisms/blog_card/BlogDetailsCard';
import Api from '../../services/api/Api';
import { public_api } from "../../services/api/ApiList";

export default function BlogDetails() {

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const { slug } = useParams();

  useEffect(() => {
    setLoading(true);
    Api.get(public_api.cms.get_blogs, {
      params: {
        populate: {
          image: {
            fields: "url"
          }
        },
        filters: {
          slug: {
            $eq: slug
          }
        }
      }
    }).then(({ data }) => {
      console.log("data.data[0]")
      console.log(data.data[0])
      setBlog(data.data[0]);
    }).finally(() => {
      setLoading(false)
    })
  }, [])

  return (
    <div className="other-page-container bg-color-brand-color4 color-111">

      <Container className="mt-20 blog-container">
        <ul className="bread-crumb">
          <li>
            <NavLink to="/blogs">
              Blogs
            </NavLink>
          </li>
          <li>{slug}</li>
        </ul>
      </Container>

      <Container className="py-30 blog-container">
        {
          loading ? <InlineLoader text="loading blogs..." /> : ''
        }

        {blog ?
          <BlogDetailsCard className="mb-40" data={blog} />
          : ''}
      </Container>
    </div>
  )
}